/* eslint-disable no-console */

export default class Logger {
  constructor(prependedMessage, isDebugMethod) {
    this.prependedMessage = prependedMessage;
    this.isDebugMethod = isDebugMethod;
  }

  log(...messages) {
    this.fire('log', ...messages);
  }

  debug(...messages) {
    if (this.isDebugMethod()) {
      this.fire('log', ...messages);
    }
  }

  warn(...messages) {
    this.fire('warn', ...messages);
  }

  error(...messages) {
    this.fire('error', ...messages);
  }

  fire(handler, ...messages) {
    console[handler](this.prependedMessage, ...messages);
  }
}



// WEBPACK FOOTER //
// ./~/logger-factory/src/logger.js